import { cheerioLoad } from '../cheerio/cheerio';

type FunctionArguments<T> = { (arg: any): T };

export function pipe(...fns: FunctionArguments<any>[]) {
  return (arg: any) => fns.reduce((prev, fn) => fn(prev), arg);
}

export function pipeWith(arg: any, ...fns: FunctionArguments<any>[]) {
  return pipe(...fns)(arg);
}

export function normalizeHtml(arg: string | null | undefined, ...fns: FunctionArguments<any>[]): string | undefined {
  if (!arg) {
    return undefined;
  }

  // isDocument parameter of cheerio load is set to false as to avoid body, head and other tags being added by cheerio
  // compare https://cheerio.js.org/modules.html#load [25.04.2022]
  const result = pipeWith(cheerioLoad(arg), ...fns);

  if (!result) {
    return undefined;
  }

  return result.html();
}
